var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 detail_header",staticStyle:{"font-size":"26px"}},[_c('div',[_vm._v(_vm._s(_vm.$props.title))]),_c('div',[_vm._v("จำนวนรวม "),_c('b',[_vm._v(_vm._s(_vm.$props.price))]),_vm._v(" "+_vm._s(_vm.$props.type))])])
}
var staticRenderFns = []

export { render, staticRenderFns }